import { registerHandler } from '../paymentHandlerRegistry';

/**
 * BNPL payment handler.
 * Handle non-Yuno BNPL providers (Aplazo, Kueski Pay) by dispatching the
 * standard bnplPaymentAttempt action, which routes to the right engine via
 * the BNPL factory.
 */
const bnplPaymentHandler = {
  execute: async ({ onBnplPaymentAttempt }) => {
    await onBnplPaymentAttempt();
  },
};

registerHandler('bnpl', bnplPaymentHandler);
